import React, { useState } from 'react';

import { ContentsItem, useContents } from 'features/contents';
import { Flex, Typography } from 'components';
import styled from 'styled-components';
import { Icon } from 'components/icon';

interface ContentsProps {
  name: string;
  items: ContentsItem[];
}

const ModuleIcon = styled(Icon)`
  width: 26px;
`;

const Contents = ({ name, items }: ContentsProps) => {
  const [opened, setOpened] = useState(false);

  const { contentDetails } = useContents();

  return (
    <Flex flexDirection="column" mb="1px">
      <Flex
        alignItems="center"
        flexWrap="nowrap"
        justifyContent="space-between"
        py={3}
        px={3}
        onClick={() => setOpened(!opened)}
        style={{ cursor: 'pointer' }}
        bg="dark_350"
      >
        <Typography type="type2" color="white" lineHeight={1.3} mr={3}>
          {name}
        </Typography>

        <ModuleIcon icon={!opened ? 'chevronDown' : 'chevronUp'} />
      </Flex>

      {opened && (
        <>
          {items.map((item) => {
            return (
              <div>
                {contentDetails?.contentUuid === item.uuid ? 'ESSESSE' : ''}
                CONTENT: {item.name}
              </div>
            );
          })}
        </>
      )}
    </Flex>
  );
};

export default Contents;
